import {Aggregations} from '../search/search-types';
import React from 'react';
import {ListGroup} from 'react-bootstrap';
import {TagGroupComponent} from './tagGroupComponent';

type AggregationListComponentProps = {
    aggregations: Aggregations;
};

export const AggregationListComponent = React.memo((props: AggregationListComponentProps) => {
    if (!props?.aggregations) {
        return null;
    }
    return (
        <div id="aggregations-list">
            <ListGroup>
                {Object.keys(props.aggregations)
                    .reverse()
                    .map((key) => (
                        <TagGroupComponent
                            key={key}
                            tagTitle={key}
                            values={props.aggregations[key]}
                        />
                    ))}
            </ListGroup>
        </div>
    );
});
